var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"color":"red","value":_vm.content,"content":_vm.content,"overlap":""}},[_c('v-btn',{attrs:{"dark":"","icon":"","text":"","to":{name:'CustomerOrderPage'}}},[_c('v-icon',[_vm._v("shopping_cart")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }